import { createRequestAction } from "./shared"
import ActionTypes from "actions/actionTypes"
import { getContentfulClient } from "../lib/contentful/contentfulClient"

const fetchPageSets = createRequestAction(ActionTypes.FETCH_PAGE_SETS, async function () {
  const client = getContentfulClient()
  return await client.getEntries({ content_type: "pageSet", include: 10 })
})

export { fetchPageSets }
